import { yupResolver } from "@hookform/resolvers/yup";
import { PropTypes } from "prop-types";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormContainer } from "@/components";
import { driveManagementFolderFormData, identifiersData } from "@/data";
import { useDriveManagementFolderSchema } from "@/schemas";
import { StyledTextField } from "@/styles";
import { renderFormControllerHandler } from "@/utils";

const DriveManagementFolderForm = ({ action, onSubmitForm, setModalData, values }) => {
    const { t } = useTranslation();

    const schema = useDriveManagementFolderSchema();

    const formMethods = useForm({
        defaultValues: values,
        mode: "onChange",
        resolver: yupResolver(schema),
    });

    const {
        control,
        formState: { errors },
    } = formMethods;

    const renderFormControllerChildrenHandler = (field, label, name) => (
        <StyledTextField
            {...field}
            error={errors[name]}
            helperText={errors?.[name]?.message}
            id={`${name}_${identifiersData.ids.input}`}
            label={t(`labels.${label}`)}
            variant="outlined"
            fullWidth
        />
    );

    return (
        <FormContainer
            action={action}
            formMethods={formMethods}
            setModalData={setModalData}
            data={renderFormControllerHandler(
                control,
                driveManagementFolderFormData,
                renderFormControllerChildrenHandler,
            )}
            hasCancelButton
            withoutShadow
            onSubmitForm={onSubmitForm}
        />
    );
};

export default DriveManagementFolderForm;

DriveManagementFolderForm.propTypes = {
    action: PropTypes.string,
    onSubmitForm: PropTypes.func,
    setModalData: PropTypes.func,
    values: PropTypes.object,
};
